module.exports = __webpack_public_path__ + "static/media/organizador_icon.c5858d86.png";